import { makeAutoObservable, runInAction } from "mobx";

import { authService } from "@/shared/api";

import { userService } from "../api/userService";
import { IUser } from "./types";

export class UserStore {
  user: IUser | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async getPassportOAuthUrl() {
    const params = new URLSearchParams([
      ["redirect_url", window.location.href],
    ]);
    const { url } = await authService.getPassportOAuthUrl(params);
    return url;
  }

  async getMe() {
    const response = await userService.getMe();

    runInAction(() => {
      this.user = response;
    });

    return response;
  }
}
